import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CashierTransactionsService {

    constructor(private http: HttpClient) { }

    adjustCashDifferences(tellerId: string, dateFromStr: string, dateToStr: string, data: any): Observable<any> {
        return this.http.get(`/cashiers/${tellerId}/transactions?orderby=transactionDate&ascending=true&dateFromStr=${dateFromStr}&dateToStr=${dateToStr}`, data);
    }

    undoTransacion(tellerId: string, transactionId: string, data: any): Observable<any> {
        return this.http.put(`/cashiers/${tellerId}/transactions/undo/${transactionId}`, data);
    }    
}
